module.exports = __webpack_public_path__ + "fonts/Catamaran-Regular.2175f69a.woff2";